import { TDaysOfWeekSchema } from '../schema/DaysOfWeekSchema'

/**
 * Returns true if there is at least one day with a value of true
 * @param daysOfWeek
 * @returns boolean
 */
export const isDaysOfWeekValid = (daysOfWeek: TDaysOfWeekSchema): boolean => {
  return Object.values(daysOfWeek).includes(true)
}
